export default "__VITE_ASSET__CqzY$WFa__"